import { message } from 'antd';
import { userHandleLogout } from 'redux/reducer/user/userReducer';
import { store } from 'redux/store';

export const localApiCatcher = (errorResponse) => {
  if (errorResponse.networkError?.message === 'Network Error') {
    message.error('اینترنت یا سرور قطع می‌باشد. دوباره تلاش کنید');
  }

  // else if (errorResponse.networkError?.code === 'ECONNABORTED') {
  //   message.error('پاسخی از سمت سرور دریافت نشد. صفحه را رفرش کنید');
  // }
  else if (errorResponse?.error?.status === 401) {
    store.dispatch(userHandleLogout());
    // message.error(errorResponse?.error?.data?.Message || errorResponse?.error?.data?.message);
  } else if (errorResponse?.error?.status === 403) {
    // store.dispatch(userHandleLogout());
    message.error('شما به این بخش دسترسی ندارید');
  } else if (errorResponse?.error) {
    message.error(errorResponse?.error?.data?.Message || errorResponse?.error?.data?.message || errorResponse?.error?.data);
  }
};
